import ConfirmModal from 'components/ConfirmModal';
import React from 'react';
import { useSelector } from 'react-redux';
import { getMaxLengthTranslation, getTranslationEmptyOrNullKey } from 'utils/getTranslation';
import style from './ConfirmExitWithoutSaveModal.module.scss';

const ConfirmExitWithoutSaveModal = ({ show, handleExit, setShow }) => {
  const translations = useSelector(state => state.translations);

  const confirmTitle =
    getMaxLengthTranslation(
      `MDP_MetodosDePago_ModalSinGuardarMDP_Titulo_Texto`,
      translations,
      37,
    );

  const descriptionTitle =
    getMaxLengthTranslation(
      `MDP_MetodosDePago_ModalSinGuardarMDP_Parrafo_Texto`,
      translations,
      74,
    );

  const confirmDeleteBtn =
    getTranslationEmptyOrNullKey(
      `MDP_Boton_Texto_SeguirEditando`,
      translations,
    ) || ``;

  const cancelBtn =
    getTranslationEmptyOrNullKey(
      `MDP_Boton_Texto_SalirSinGuardar`, // todo: llave provisional (no está)
      translations,
    ) || ``;

  return (
    <ConfirmModal
      open={show}
      title={confirmTitle}
      description={descriptionTitle}
      confirmText={confirmDeleteBtn}
      cancelText={cancelBtn}
      onConfirm={() => {
        setShow(false);
      }}
      onCancel={() => handleExit()}
      cssStyle={style}
      maxCharsPerLine={37}
    />
  );
};

export default ConfirmExitWithoutSaveModal;
